import React from "react";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { Colors } from "../../utils/constants/colors";

interface SubjectHeaderProps {
    title: string;
    description: string;
    className?: string;
    right?: React.ReactNode
}

export default function SubjectHeader(props: SubjectHeaderProps) {

    const { title, description } = props

    const navigate = useNavigate()

    return (
        <div className={`subject_header ${props.className}`}>
            <div className={`subject_header_left  ${props.right ? 'half' : 'full'}`}>
                <div className="back_button" onClick={() => navigate(-1)}>
                    <IoIosArrowBack size={28} color={Colors.primary} />
                </div>

                <div className='subject_header_content'>

                    <h2 className="new_heading">{title}</h2>
                    <p className="heading_desc">{description}</p>
                </div>
            </div>

            <div className="subject_header_right">
                {props.right}
            </div>


        </div>
    )
}
